import { getYmAnalyticsId } from '@r1-frontend/shared/helpers/getYmId';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';
import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

export type { ResponseDto } from './dto/ResponseDto';
export type { RequestDto };
export { ERequestStatus } from './dto/ERequestStatus';

/**
 * Создание заявки на подключение
 * https://master.api-request.sandbox.d2c.r-one.io/docs/v1#/RequestByConnection/8c545c8dcd28e73bf95ac9e063c53463
 */
export const requestByConnection = ({ check_call_type, csrf, ...body }: RequestDto): IRequest => {
    if (isClientSide() && !check_call_type) {
        check_call_type = window.location.pathname;
    }
    return {
        uri: '/v1/user/request-by-connection',
        method: 'POST',
        withProvider: true,
        body: JSON.stringify({
            check_call_type,
            ...body,
            ...getYmAnalyticsId(),
        }),
        headers: {
            'x-csrf-token': csrf,
        },
    };
};
